import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem, Stack } from "@mui/material";
import axios from "axios";

type Underwriter = {
  payeeName: string;
  underwriterLookupCode: string;
  lookupCode: string;
};

type Props = {
  open: boolean;
  onClose: () => void;
  onSave: (underwriter: Underwriter) => void;
  titleCompanyLookupCode: string | undefined | null;
};

const EditUnderwriterModal: React.FC<Props> = ({ open, onClose, onSave, titleCompanyLookupCode }) => {
  const [underwriters, setUnderwriters] = useState<Underwriter[]>([]);
  const [selectedLookupCode, setSelectedLookupCode] = useState<string>("");

  useEffect(() => {
    if (!open || !titleCompanyLookupCode) return;

    axios
      .get<Underwriter[]>(`/proxy/api/underwriters/getbytitlecompany?titlecompany=${titleCompanyLookupCode}`)
      .then((res) => {
        setUnderwriters(res.data);
      })
      .catch((err) => {
        console.error("Failed to load underwriters", err);
      });
  }, [open, titleCompanyLookupCode]);

  const selectedUnderwriter = underwriters.find((u) => u.lookupCode === selectedLookupCode);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Underwriter</DialogTitle>
      <DialogContent>
        <Stack spacing={3} mt={1}>
          <TextField
            label="Title Company Lookup Code"
            value={titleCompanyLookupCode || ""}
            variant="filled"
            fullWidth
            InputProps={{
              readOnly: true,
              disableUnderline: true
            }}
            sx={{ backgroundColor: "#f5f5f5" }}
          />
          <TextField
            select
            label="Underwriter"
            value={selectedLookupCode}
            onChange={(e) => setSelectedLookupCode(e.target.value)}
            fullWidth
          >
            {underwriters.map((u) => (
              <MenuItem key={u.lookupCode} value={u.lookupCode}>
                {u.payeeName}
              </MenuItem>
            ))}
          </TextField>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={() => {
            if (selectedUnderwriter) {
              onSave(selectedUnderwriter);
            }
          }}
          disabled={!selectedUnderwriter}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditUnderwriterModal;
